import AddPage from './AddPage.js'
import { BasePage as CngBasePage } from 'cng-web-lib'
import EditPage from './EditPage.js'
import React from 'react'
import TablePage from './TablePage.js'
import ViewPage from './ViewPage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'
import ACRLookupsProvider from '../lookups/ACRLookupsContext'

function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <ACRLookupsProvider>
      <CngBasePage
        renderPage={(showSnackbar) => (
          <TablePage showNotification={showSnackbar} {...props} />
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
    </ACRLookupsProvider>
  )
}

function WrappedAddPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <ACRLookupsProvider>
      <CngBasePage
        renderPage={(showSnackbar) => (
          <AddPage showNotification={showSnackbar} {...props} />
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
    </ACRLookupsProvider>
  )
}

function WrappedEditPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <ACRLookupsProvider>
      <CngBasePage
        renderPage={(showSnackbar) => (
          <EditPage showNotification={showSnackbar} {...props} />
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
    </ACRLookupsProvider>
  )
}

function WrappedViewPage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <ACRLookupsProvider>
      <CngBasePage
        renderPage={(showSnackbar) => (
          <ViewPage showNotification={showSnackbar} {...props} />
        )}
        extraCngBreadcrumbNameMap={breadcrumbNameMap}
      />
    </ACRLookupsProvider>
  )
}

export {
  WrappedAddPage as AddPage,
  WrappedEditPage as EditPage,
  WrappedViewPage as ViewPage,
  WrappedTablePage as TablePage
}
